<template xmlns="http://www.w3.org/1999/html">
    <tr>
        <td :title="projects[projectId].name" class="project-name"><span @click="openProject()" class="action">{{replaceUnderscore(projects[projectId].name)}}</span></td>
        <td class="td-text currency">{{numberWithSpaces(Math.round(contractBudget))}}</td>
        <td class="td-text currency">{{numberWithSpaces(Math.round(contractBaselineCosts))}}</td>
        <td class="td-text currency" :title="contractBudget + ' - ' + contractBaselineCosts">{{numberWithSpaces(Math.round(budgetProfit))}}</td>
        <td class="td-text currency" :title="'(((' + actualsV2[projectId]/100 + ' + ' + materialCosts.materialV2/100 + ')/ (' +  etc[projectId] + ' + ' + materialCosts.materialV2/100 + ' + ' + actualsV2[projectId]/100 + ')) - ((' + actualsV1[projectId]/100 + ' + ' + materialCosts.materialV1/100 + ')/ (' +  etc[projectId] + ' + ' + materialCosts.materialV2/100 + ' + ' + actualsV2[projectId]/100 + '))* ' + contractBudget">{{numberWithSpaces(Math.round(revenuePerPeriod))}}</td>
        <td class="td-text currency" :title="actualsV2[projectId]/100 + ' - ' + actualsV1[projectId]/100">{{numberWithSpaces(Math.round((actualsV2[projectId]/100) - (actualsV1[projectId]/100)))}}</td>
        <td class="td-text currency" :title="materialCosts.materialV2/100 + ' - ' + materialCosts.materialV1/100">{{numberWithSpaces(Math.round(materialCosts.total/100))}}</td>
        <td class="td-text currency" :title="Math.round(revenuePerPeriod) + '- (' + actualsV2[projectId]/100 + ' + ' + materialCosts.materialV2/100 + ') - (' + actualsV1[projectId]/100 + ' + ' + materialCosts.materialV1/100 + ')'">{{numberWithSpaces(Math.round(profitPerPeriod))}}</td>
        <td class="td-text percentage" :title="'((' + actualsV2[projectId]/100 + ' + ' + materialCosts.materialV2/100 + ') / (' + etc[projectId] + ' + ' + materialCosts.materialV2/100 + ' + ' + actualsV2[projectId]/100 + ')) * 100' ">{{Math.round(percentageOfCompletion)}}</td>
        <td class="td-text currency">{{numberWithSpaces(Math.round(etc[projectId]))}}</td>
        <td class="td-text currency" :title="actualsV2[projectId]/100 + ' + ' + materialCosts.materialV2/100 + ' + ' + etc[projectId]">{{numberWithSpaces(Math.round(eac/100))}}</td>
        <td class="td-text currency" :title="contractBudget + ' - (' + etc[projectId] + ' + ' + materialCosts.materialV2/100 + ' + ' + actualsV2[projectId]/100 + ')'">{{numberWithSpaces(Math.round(expectedProfit))}}</td>
        <td class="td-text percentage" :title="'(' + budgetProfit + ' - ' + expectedProfit + ') / ' + budgetProfit">{{numberWithSpaces(Math.round(variance))}}</td>
    </tr>
</template>

<script>

import { mapGetters, mapActions, mapState } from 'vuex';
import moment from 'moment';

export default {
  name: 'ProjectOverviewRow',
  props: ['projectId',
    'periodFrom',
    'periodTo'
  ],
  components: {
  },
  data: function () {
    return {

    };
  },
  computed: {
    ...mapGetters('JiraProjects', ['projects']),
    ...mapGetters('ProjectsOverview', [
      'actualsV1',
      'actualsV2',
      'materialsV1',
      'materialsV2',
      'etc',
    ]),
    materialCosts() {
      const materialCost = {
        materialV1: 0,
        materialV2: 0,
        total: 0
      };
      for (var materialId in this.materialsV2) {
        var material = this.materialsV2[materialId];
        if (material.project_id == this.projectId) {
          materialCost.total += parseInt(material.cost);
          materialCost.materialV2 = parseInt(material.cost);
        }
      }
      for (var materialId in this.materialsV1) {
        var material = this.materialsV1[materialId];
        if (material.project_id == this.projectId) {
          materialCost.total -= parseInt(material.cost);
          materialCost.materialV1 = parseInt(material.cost);
        }
      }
      return materialCost;
    },
    profitPerPeriod() {
      const labourV1 = Math.round((this.actualsV1[this.projectId] / 100));
      const labourV2 = Math.round((this.actualsV2[this.projectId] / 100));
      let materialV1 = 0;
      let materialV2 = 0;
      for (var materialId in this.materialsV1) {
        var material = this.materialsV1[materialId];
        if (material.project_id == this.projectId) {
          materialV1 += parseInt(material.cost);
        }
      }
      for (var materialId in this.materialsV2) {
        var material = this.materialsV2[materialId];
        if (material.project_id == this.projectId) {
          materialV2 += parseInt(material.cost);
        }
      }
      const costs = (labourV2 + (materialV2 / 100)) - (labourV1 + (materialV1 / 100));
      return this.revenuePerPeriod - costs;
    },
    revenuePerPeriod() {
      let revenue = 0;
      const pocv1 = (this.actualsV1[this.projectId] + this.materialCosts.materialV1) / this.eac;
      const pocv2 = (this.actualsV2[this.projectId] + this.materialCosts.materialV2) / this.eac;
      revenue = (pocv2 - pocv1) * this.contractBudget;
      return revenue;
    },
    contractBudget() {
      let budget = this.projects[this.projectId].contract_budget;
      if (this.projects[this.projectId].change_requests.length) {
        const requests = this.projects[this.projectId].change_requests;
        for (const i in requests) {
          if (requests[i].start_date <= moment(this.periodTo).format('YYYY-MM-DD')) {
            budget += requests[i].contract_budget;
          }
        }
      }
      return budget;
    },
    contractBaselineCosts() {
      let baselineCosts = this.projects[this.projectId].baseline_costs;
      if (this.projects[this.projectId].change_requests.length) {
        const requests = this.projects[this.projectId].change_requests;
        for (const i in requests) {
          if (requests[i].start_date <= moment(this.periodTo).format('YYYY-MM-DD')) {
            baselineCosts += requests[i].baseline_costs;
          }
        }
      }
      return baselineCosts;
    },
    eac() {
      return (this.etc[this.projectId] * 100) + this.materialCosts.materialV2 + this.actualsV2[this.projectId];
    },
    expectedProfit() {
      return this.contractBudget - (this.eac / 100); // contract budget instead of baseline
    },
    budgetProfit() {
      return this.contractBudget - this.contractBaselineCosts; // -budgeted cost
    },
    percentageOfCompletion() {
      return ((this.actualsV2[this.projectId] + this.materialCosts.materialV2) / this.eac) * 100;
    },
    variance() {
      const dif = this.budgetProfit - this.expectedProfit;
      if (dif < 0) {
        return (Math.abs(dif) / this.budgetProfit) * 100;
      }
      return ((dif * -1) / this.budgetProfit) * 100;
    },
  },
  methods: {
    numberWithSpaces(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    },
    replaceUnderscore(projectName) {
      return projectName.replace(/_/g, ' ');
    },
    openProject() {
      this.$router.push({ name: 'ProjectTabPlanning', params: { id: this.projectId } });
    }
  },
  mounted() {
  },
};
</script>
<style lang="scss" scoped>
    .project-name {
        text-align: center;
        /*text-overflow: ellipsis;*/
        /*overflow:hidden;*/
        /*white-space:nowrap;*/
    }
    .currency::before{
        content: "€ ";
    }
    .percentage::after{
        content: " %";
    }
    tr td:not(:first-child){
        text-align: right;
    }
    td {
        padding: 0;
    }
    .action {
        margin-left: 5px;

        &:hover {
            cursor: pointer;
            color: #ee0044;
        }
    }
    .td-text {
        vertical-align: middle;
        padding-right: 3px;
    }
</style>
